module.exports = __webpack_public_path__ + "img/ararat-reg-bg-mobile.ca8dbb15.jpg";